import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/jarl/Documents/Projects/civitas/kenobi/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <h3 {...{
      "id": "kenobi-is-a-react-ui-toolkit-for-building-interfaces-for-web-applications"
    }}>{`Kenobi is a React UI Toolkit for building interfaces for web applications.`}</h3>
    <h3 {...{
      "id": "kenobi-is-built-and-maintained-by-plateo"
    }}>{`Kenobi is built and maintained by `}<a parentName="h3" {...{
        "href": "https://www.plateo.io"
      }}>{`Plateo`}</a></h3>
    <h3 {...{
      "id": "this-project-is-built-entirely-on-react-hooks-and-typescript"
    }}>{`This project is built entirely on React hooks and Typescript.`}</h3>
    <h3 {...{
      "id": "disclaimer-this-project-is-still-under-active-development-things-will-change"
    }}><strong parentName="h3">{`Disclaimer: This project is still under active development. Things will change.`}</strong></h3>
    <h3 {...{
      "id": "most-components-are-compliant-with-wai-aria-standards-if-weve-missed-something-please-reach-out"
    }}>{`Most components are compliant with WAI ARIA standards. If we've missed something, please reach out!`}</h3>
    <h3 {...{
      "id": "quick-start"
    }}>{`Quick start`}</h3>
    <h3 {...{
      "id": "install"
    }}>{`Install`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install kenobi-ui
`}</code></pre>
    <h3 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Button } from 'kenobi-ui';

<Button>Hello from Kenobi!</Button>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      